import React, { useState } from 'react';
import LocalhostModal from '../../components/LocalhostModal';

const LocalhostModalPage: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ padding: 40 }}>
      <h2>Exemplo de Modal Localhost:3333</h2>
      <button onClick={() => setIsOpen(true)}>
        Abrir modal para localhost:3333
      </button>
      <LocalhostModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default LocalhostModalPage;
